module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/desktop-b4d2657277d44571a7181e6d34f58819.jpg";